export default "__VITE_ASSET__DmypC1H$__"